import * as React from "react";
import { Control, useFieldArray, useWatch } from "react-hook-form";
import {
  Text,
  Grid,
  Title,
  Modal,
  ActionIcon,
  Button,
  ScrollArea,
  Table,
  Group,
  Flex,
} from "@mantine/core";
import { IconPlus, IconTrash } from "@tabler/icons-react";

import {
  CSelect,
  CTextInput,
  CCheckbox,
  CMultiSelect,
  CTextarea,
} from "@supportinitiative/react-hook-form-mantine";

import { ReconsetCVMContext } from "./ReconsetCVM";
import { getId } from "src/utilities";

function DashboardCVM({
  name,
  control,
}: {
  name: `definition.dashboards.${number}`;
  control: Control<any>;
}) {
  const { state: reconsetFormState } = React.useContext(ReconsetCVMContext);

  let [isOpen, setIsOpen] = React.useState(false);

  const displayColumnsArray = useFieldArray({
    control,
    name: `${name}.displayColumns`,
    keyName: "key",
  });

  const dashboardName = useWatch({
    control,
    name: `${name}.name`,
  });

  const displayColumns = useWatch({
    control,
    name: `${name}.displayColumns`,
  });

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
      }}
    >
      <Button
        fullWidth
        variant="default"
        onClick={() => {
          setIsOpen(!isOpen);
        }}
      >
        {dashboardName ? dashboardName : "Dashboard"}
      </Button>

      <Modal
        centered
        size={"100%"}
        opened={isOpen}
        onClose={() => setIsOpen(!isOpen)}
        title={<Title order={4}>Dashboard</Title>}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Grid align="stretch" gutter={"xs"} mb="xs">
            <Grid.Col span={12}>
              <CTextInput
                name={`${name}.id`}
                label="ID"
                control={control}
                required
                disabled={true}
              />
            </Grid.Col>
          </Grid>
          <Grid align="stretch" gutter={"xs"} mb="xs">
            <Grid.Col span={12}>
              <CTextInput
                name={`${name}.name`}
                label="Name"
                control={control}
                required
                disabled={reconsetFormState.actionOptions.disableAll}
              />
            </Grid.Col>
          </Grid>
          <Grid align="stretch" gutter={"xs"} mb="xs">
            <Grid.Col span={12}>
              <CTextarea
                name={`${name}.genFunction`}
                control={control}
                label={"Generate Function"}
                minRows={4}
                autosize
                disabled={reconsetFormState.actionOptions.disableAll}
                required
              />
            </Grid.Col>
          </Grid>

          <Group mb="xs" align="center" style={{ alignItems: "center" }}>
            <Flex>
              <Text fw={500} style={{ fontSize: "14px" }}>
                Display Columns
              </Text>
            </Flex>
            <ActionIcon
              size="sm"
              variant="white"
              color="gray"
              onClick={() => {
                displayColumnsArray.append({
                  name: "",
                  type: "BADGE",
                  field1: "",
                  field2: "",
                  field3: "",
                  id: getId(),
                });
              }}
              style={{
                display:
                  reconsetFormState.currentAction.toUpperCase() === "VIEW"
                    ? "none"
                    : "",
              }}
              disabled={reconsetFormState.actionOptions.disableAll}
            >
              <IconPlus />
            </ActionIcon>
          </Group>

          <div
            style={
              {
                // overflow: "scroll",
              }
            }
          >
            {displayColumnsArray.fields.map((field, index) => {
              return (
                <Grid
                  align="stretch"
                  gutter={"xs"}
                  mb="xs"
                  key={field.key}
                  columns={24}
                >
                  <Grid.Col span={3}>
                    <CTextInput
                      name={`${name}.displayColumns.${index}.name`}
                      control={control}
                      showErrorText={false}
                      label={index === 0 ? "Name" : ""}
                      required
                      disabled={reconsetFormState.actionOptions.disableAll}
                    />
                  </Grid.Col>
                  <Grid.Col span={3}>
                    <CTextInput
                      name={`${name}.displayColumns.${index}.label`}
                      control={control}
                      showErrorText={false}
                      label={index === 0 ? "Lebel" : ""}
                      required
                      disabled={reconsetFormState.actionOptions.disableAll}
                    />
                  </Grid.Col>

                  <Grid.Col span={3}>
                    <CSelect
                      name={`${name}.displayColumns.${index}.type`}
                      control={control}
                      clearable
                      searchable
                      label={index === 0 ? "Type" : ""}
                      data={[
                        { label: "Badge", value: "BADGE" },
                        { label: "Text", value: "TEXT" },
                      ]}
                      required
                      disabled={reconsetFormState.actionOptions.disableAll}
                    />
                  </Grid.Col>
                  <Grid.Col span={4}>
                    <CTextarea
                      name={`${name}.displayColumns.${index}.value1`}
                      control={control}
                      showErrorText={false}
                      label={index === 0 ? "Value 1" : ""}
                      disabled={reconsetFormState.actionOptions.disableAll}
                    />
                  </Grid.Col>
                  <Grid.Col span={4}>
                    <CTextarea
                      name={`${name}.displayColumns.${index}.value2`}
                      control={control}
                      showErrorText={false}
                      label={index === 0 ? "Value 2" : ""}
                      disabled={reconsetFormState.actionOptions.disableAll}
                    />
                  </Grid.Col>
                  <Grid.Col span={4}>
                    <CTextarea
                      name={`${name}.displayColumns.${index}.value3`}
                      control={control}
                      showErrorText={false}
                      label={index === 0 ? "Value 3" : ""}
                      disabled={reconsetFormState.actionOptions.disableAll}
                    />
                  </Grid.Col>
                  <Grid.Col
                    span={2}
                    style={{ display: "flex", alignItems: "flex-end" }}
                  >
                    <CTextInput
                      name={`${name}.displayColumns.${index}.id`}
                      control={control}
                      label={index === 0 ? "Id" : ""}
                      disabled={true}
                    />
                  </Grid.Col>

                  <Grid.Col
                    span={1}
                    style={{ display: "flex", alignItems: "flex-end" }}
                  >
                    <ActionIcon
                      size="sm"
                      variant="white"
                      color="gray"
                      onClick={() => {
                        displayColumnsArray.remove(index);
                      }}
                      disabled={reconsetFormState.actionOptions.disableAll}
                    >
                      <IconTrash />
                    </ActionIcon>
                  </Grid.Col>
                </Grid>
              );
            })}
          </div>

          <Grid align="stretch" gutter={"xs"} mt="xs">
            <Grid.Col span={2}>
              <Button color="teal" fullWidth onClick={() => setIsOpen(!isOpen)}>
                Ok
              </Button>
            </Grid.Col>
          </Grid>
        </div>
      </Modal>
    </div>
  );
}

export default DashboardCVM;
